import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
interface ShortcutConfig {
  key: string;
  path: string;
  description: string;
  adminOnly?: boolean;
  guardOnly?: boolean;
}
const shortcuts: ShortcutConfig[] = [{
  key: "1",
  path: "/guards",
  description: "Guard Management"
}, {
  key: "2",
  path: "/teams",
  description: "Team Overview"
}, {
  key: "3",
  path: "/reports",
  description: "Reports & Submissions"
}, {
  key: "4",
  path: "/missions",
  description: "Work Instructions"
}, {
  key: "5",
  path: "/scheduling",
  description: "Scheduling"
}, {
  key: "6",
  path: "/alerts",
  description: "Incident Alerts",
  adminOnly: true
}, {
  key: "h",
  path: "/",
  description: "Home Dashboard"
}, {
  key: "?",
  path: "",
  description: "Show shortcuts help"
}];
export const useKeyboardShortcuts = () => {
  const navigate = useNavigate();
  const {
    toast
  } = useToast();
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      // Don't trigger if user is typing in an input
      if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement || event.target instanceof HTMLSelectElement || (event.target as HTMLElement)?.isContentEditable) {
        return;
      }

      // Don't trigger if modifier keys are pressed
      if (event.ctrlKey || event.altKey || event.metaKey) {
        return;
      }
      const shortcut = shortcuts.find(s => s.key === event.key);
      if (shortcut) {
        event.preventDefault();
        if (shortcut.key === "?") {
          showShortcutsHelp();
          return;
        }
        navigate(shortcut.path);
        toast({
          title: `Navigated to ${shortcut.description}`,
          description: `Keyboard shortcut: ${shortcut.key}`,
          duration: 2000
        });
      }
    };
    const showShortcutsHelp = () => {
      const helpText = shortcuts.filter(s => s.key !== "?").map(s => `${s.key}: ${s.description}`).join('\n');
      toast({
        title: "Keyboard Shortcuts",
        description: <div className="space-y-1 font-mono text-xs">
            {shortcuts.filter(s => s.key !== "?").map(s => <div key={s.key} className="flex justify-between">
                  <span className="font-bold">{s.key}</span>
                  <span>{s.description}</span>
                </div>)}
            <div className="pt-2 text-muted-foreground">
              Press ? to show this help again
            </div>
          </div>,
        duration: 8000
      });
    };
    document.addEventListener('keypress', handleKeyPress);
    return () => {
      document.removeEventListener('keypress', handleKeyPress);
    };
  }, [navigate, toast]);
};

// Component to show keyboard shortcuts indicator
export const KeyboardShortcutsIndicator = () => {
  return <div className="fixed bottom-4 right-4 z-50 opacity-60 hover:opacity-100 transition-opacity">
      
    </div>;
};